module.exports = __webpack_public_path__ + "img/thumbnailvideo-media.b687332c.png";